export enum FuelType {
  Chemical = 'chemical',
  Nuclear = 'nuclear',
}
